import React from "react"
import { useNavigate, } from "react-router-dom"
import { RiArrowLeftSLine, } from "react-icons/ri"

import "./BackButton.scss"

export default function BackButton() {
  const navigate = useNavigate()

  function handleOnClick() {
    navigate(-1)
  }

  return (
    <div className="back-btn-container" onClick={handleOnClick}>
      <RiArrowLeftSLine className="left-arrow" /> <span>Back</span>
    </div>
  )
}
